import { FC } from 'react';
import { MAP_TAG_BUTTONS } from 'utils/constants';
import { MapData } from '../type';
import { MdLocationOn } from 'react-icons/md';
import { Button } from '../../button';
import Link from 'next/link';
import { PartnerStock } from './map-plus-sidebar';
import { Glimmer } from '@/components/button/glimmer';

export const PartnerCard: FC<{
  data: MapData;
  stock?: PartnerStock;
  onChangeOpen: (data: MapData) => void;
}> = ({ data, stock, onChangeOpen }) => {
  const attr = data.attributes;

  const getTagClass = (name: string) => {
    switch (name) {
      case MAP_TAG_BUTTONS.franchise:
      case MAP_TAG_BUTTONS.lowStock:
        return 'red-tag-button';
      case MAP_TAG_BUTTONS.installer:
        return 'violet-tag-button';
      case MAP_TAG_BUTTONS.online:
      case MAP_TAG_BUTTONS.inStock:
        return 'green-tag-button';
      case MAP_TAG_BUTTONS.retail:
        return 'orange-tag-button';
      case MAP_TAG_BUTTONS.dealer:
        return 'blue-tag-button';
      default:
        return;
    }
  };

  return (
    <div className='flex flex-col'>
      <div className='items-left flex flex-row gap-2 text-left'>
        {data.dispatch && (
          <span className={'red-tag-button'}>{MAP_TAG_BUTTONS.franchise}</span>
        )}

        {stock && !stock.outOfStock && !stock.lowStock && (
          <span className={`${getTagClass(MAP_TAG_BUTTONS.inStock)}`}>
            {MAP_TAG_BUTTONS.inStock}
          </span>
        )}

        {stock && stock.lowStock && (
          <span className={`${getTagClass(MAP_TAG_BUTTONS.lowStock)}`}>
            {MAP_TAG_BUTTONS.lowStock}
          </span>
        )}

        {stock && stock.price && stock.clickThruUrl && (
          <Link
            href={stock.clickThruUrl}
            className='tag-button relative overflow-hidden border border-gray-600 text-xs font-bold text-gray-600'
          >
            Buy Now: ${stock.price}
            <Glimmer />
          </Link>
        )}

        {data?.attributes?.store_types?.data?.map((item, index) => (
          <span
            key={item.id || index}
            className={`${getTagClass(item.attributes.name)}`}
          >
            {item.attributes.name}
          </span>
        ))}
      </div>
      <div className='flex flex-row items-center pt-4 text-left'>
        <MdLocationOn className='size-8 flex-shrink-0 text-primary' />
        <span
          className='overflow-hidden overflow-ellipsis whitespace-nowrap pl-2 text-base font-semibold'
          title={attr?.title || 'undefined'}
        >
          {attr?.title || 'undefined'}
        </span>
      </div>
      <div className='flex flex-row items-center justify-between pt-4'>
        {data.dispatch && (
          <div className='text-left'>
            <Button
              variant='custom'
              onClick={() => onChangeOpen(data)}
              className='w-full max-w-fit rounded-full bg-primary px-3 py-1.5 text-xs text-white hover:bg-primary-dark hover:text-white'
            >
              Get custom quote
            </Button>
          </div>
        )}

        <span className='cursor-pointer justify-end border-b border-dashed border-gray-600'>
          more info
        </span>
      </div>
    </div>
  );
};
